export class Educator {
  public id: string;
  public firstName: string;
  public lastName: string;
  public title: string;
  public specialty: string;
  public pictureUrl: string;
}
